export class UnauthorizedAccessError extends Error {
  constructor() {
    super('unauthorized-access')
  }
}

export class UserDataLoadError extends Error {
  constructor() {
    super('user-data-load-error')
  }
}

export class RateLimitError extends Error {
  constructor() {
    super('rate-limit')
  }
}

export class EmptyEmailError extends Error {
  constructor() {
    super('empty-email')
  }
}

export class InvalidEmailError extends Error {
  constructor() {
    super('invalid-email')
  }
}
